<div>
    <div class="container">
        <bko-kartlegg-card/>
        <bko-slik-fungerer-boligkompasset/>
    </div>
</div>
